import axios from 'axios';

/**
 * Fetch the JPM UID (create a session) for a keyholder.
 */
const getJpmUidKeyholder = async ({
  cssUrl,
  cardholderName,
}: {
  cssUrl: string;
  cardholderName: string;
}): Promise<string | undefined> => {
  try {
    const { data } = await axios.get<string>(
      `/supra/jpm_uid_keyholder/${encodeURIComponent(
        cssUrl,
      )}/${encodeURIComponent(cardholderName)}`,
    );
    return data;
  } catch {
    return undefined;
  }
};

export default getJpmUidKeyholder;
